export default __webpack_public_path__ + "static/media/03.4c9850cf.jpg";